import { REFERRAL_DISCOUNT } from '../../constants';

export const STANDARD_TITLE = 'Choose your subscription';
export const BLACK_FRIDAY_DISCOUNT =
  'Black Friday Deal - Save £200 on a yearly subscription';
export const REFERRED_TITLE = `Choose your subscription (yearly subscription includes £${REFERRAL_DISCOUNT} referral discount)`;
